module.exports = __webpack_public_path__ + "img/salesforce-mini.c3065813.png";